// ========================================
// Profesores → «El curso»: each person's contracts drawn from September to August, so the
// course's hires, ends, repeated contracts and freelance periods read at a glance.
// Shares the search and pay-type filter of ProfessorsView; only for staff managers.
// ========================================

const ProfessorsCourse = {
    MONTHS: ['Sep', 'Oct', 'Nov', 'Dic', 'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago'],

    /** Days from 1 September of the course to an ISO date (clamped to the course). */
    position(iso, from, days) {
        const d = Math.round((new Date(`${iso}T12:00:00`) - from) / 86400000);
        return Math.max(0, Math.min(days, d));
    },

    render(allProfessors, yearStart) {
        const view = ProfessorsView;
        const first = `${yearStart}-09-01`, last = `${yearStart + 1}-08-31`;
        const from = new Date(`${first}T12:00:00`), days = Math.round((new Date(`${last}T12:00:00`) - from) / 86400000) + 1;
        const pct = n => `${(n / days * 100).toFixed(3)}%`;
        const fmt = iso => new Date(`${iso}T12:00:00`).toLocaleDateString('es-ES', { day: 'numeric', month: 'short' });
        const today = view.todayIso();
        const todayIn = today >= first && today <= last;

        // People with some contract in this course, after the search and the pay-type filter.
        const people = view.getProcessedProfessors(allProfessors)
            .filter(p => view.payFilter === 'all' || view.payKindOf(p) === view.payFilter)
            .map(p => ({ p, contracts: StaffPay.contractsOf(p).filter(c => c.startDate <= last && (!c.endDate || c.endDate >= first)) }))
            .filter(row => row.contracts.length);

        const bar = (p, c) => {
            const a = this.position(c.startDate < first ? first : c.startDate, from, days);
            const b = this.position(!c.endDate || c.endDate > last ? last : c.endDate, from, days) + 1;
            const untold = !c.freelance && !c.advisoryNotified && c.startDate >= view.addDays(today, -60);
            const kind = c.freelance ? 'is-freelance' : untold ? 'is-untold' : 'is-payroll';
            const label = `${c.startDate < first ? 'antes' : fmt(c.startDate)} – ${c.endDate ? fmt(c.endDate) : 'sin baja'}${c.freelance ? ' · autónomo' : untold ? ' · sin avisar' : ''}`;
            return `<button type="button" class="pc-bar ${kind}" style="left: ${pct(a)}; width: ${pct(Math.max(1, b - a))}" title="${Utils.sanitizeHTML(label)}" aria-label="${Utils.sanitizeHTML(`${p.firstName} ${p.lastName}: ${label}`)}"
                ${UIEvents.attr("click", function(event,captured){App.navigate('profesor/' + String(captured[0]));}, [p.id])}><span>${Utils.sanitizeHTML(label)}</span></button>`;
        };

        const kinds = [['all', 'Todos'], ...Object.entries(view.PAY_KIND_LABELS)];
        return `
            <section class="pn-card pn-toolbar" aria-label="Filtros">
                <label class="pn-search pl-search">
                    <i class="fas fa-search" aria-hidden="true"></i>
                    <input type="search" id="professor-search" placeholder="Buscar persona" aria-label="Buscar persona" value="${Utils.sanitizeHTML(view.searchTerm)}">
                </label>
                <div class="pn-segment pl-situations" role="group" aria-label="Tipo de pago">
                    ${kinds.map(([key, label]) => `<button type="button" aria-pressed="${view.payFilter === key}" class="${view.payFilter === key ? 'is-on' : ''}" ${UIEvents.attr("click", function(event,captured){ProfessorsView.setFilter('payFilter',String(captured[0]));}, [key])}>${label}</button>`).join('')}
                </div>
                <span class="pn-grow"></span>
                <span class="pn-legend">
                    <span><span class="pc-swatch is-payroll"></span>Contrato (nómina)</span>
                    <span><span class="pc-swatch is-freelance"></span>Autónomo (factura)</span>
                    <span><span class="pc-swatch is-untold"></span>Alta sin avisar</span>
                </span>
            </section>
            <section class="pn-card pn-table-card pl-table-card" aria-label="Contratos del curso por persona">
                <div class="pn-scroll">
                    <div class="pc-grid">
                        <div class="pc-row pc-head">
                            <span class="pc-person">Persona</span>
                            <span class="pc-months">${this.MONTHS.map(m => `<span>${m}</span>`).join('')}</span>
                            <span class="pc-hours">Horas</span>
                        </div>
                        ${people.length ? people.map(({ p, contracts }) => `<div class="pc-row">
                            <span class="pc-person pn-person">
                                <span class="pn-avatar pl-avatar">${p.photo ? `<img ${StudentPhotos.attributes(p.photo)} alt="">` : Utils.sanitizeHTML(view.getInitials(p.firstName, p.lastName))}</span>
                                <span class="pn-person-text">
                                    <button type="button" class="pn-person-name pn-person-link" ${UIEvents.attr("click", function(event,captured){App.navigate('profesor/' + String(captured[0]));}, [p.id])}>${Utils.sanitizeHTML(`${p.firstName} ${p.lastName}`.trim())}</button>
                                    <span class="pn-person-kind">${Utils.sanitizeHTML(view.PAY_KIND_LABELS[view.payKindOf(p)])}</span>
                                </span>
                            </span>
                            <span class="pc-track">
                                ${todayIn ? `<span class="pc-today" style="left: ${pct(this.position(today, from, days))}" aria-hidden="true"></span>` : ''}
                                ${contracts.map(c => bar(p, c)).join('')}
                            </span>
                            <span class="pc-hours pl-mono">${view.getProfessorHours(p.id)} h</span>
                        </div>`).join('') : `<div class="dnr-empty pn-empty">Nadie con contrato en el curso ${yearStart} / ${yearStart + 1}${view.searchTerm ? ` que coincida con «${Utils.sanitizeHTML(view.searchTerm)}»` : ''}.</div>`}
                    </div>
                </div>
            </section>
            <p class="pn-hint">${todayIn ? 'La raya es hoy. ' : ''}Pulsa un tramo o un nombre para abrir su ficha, con sus contratos, su PDF y su aviso a la asesoría.</p>`;
    }
};

window.ProfessorsCourse = ProfessorsCourse;
